var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0557 52.045C25.4447 54.3485 27.6392 55.5 30 55.5V30.5L6.59505 18.1816C6.56058 18.237 6.52675 18.2929 6.4935 18.3494C5 20.8857 5 24.0417 5 30.3538V30.6463C5 36.9583 5 40.1145 6.4935 42.6508C7.98697 45.187 10.6766 46.5985 16.0557 49.4213L21.0557 52.045Z",
    fill: "#DF7F0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.7,
    d: "M43.944 11.5788L38.944 8.95492C34.555 6.65165 32.3605 5.5 29.9997 5.5C27.639 5.5 25.4445 6.65165 21.0554 8.95492L16.0554 11.5788C10.796 14.3388 8.10775 15.7495 6.59473 18.1816L29.9997 30.5L53.4047 18.1816C51.8915 15.7495 49.2032 14.3388 43.944 11.5788Z",
    fill: "#DF7F0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.5,
    d: "M53.5065 18.3494C53.4732 18.2929 53.4395 18.237 53.405 18.1816L30 30.5V55.5C32.3607 55.5 34.5552 54.3485 38.9442 52.045L43.9442 49.4213C49.3235 46.5985 52.013 45.187 53.5065 42.6508C55 40.1145 55 36.9583 55 30.6463V30.3538C55 24.0417 55 20.8857 53.5065 18.3494Z",
    fill: "#DF7F0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.8084 11.7088C15.8904 11.6657 15.9732 11.6223 16.0565 11.5786L19.7904 9.61914L42.5423 22.1327L52.6015 17.1031C52.9458 17.4929 53.245 17.9036 53.5073 18.3491C53.8813 18.9842 54.1615 19.6581 54.3718 20.4106L44.3758 25.4086V32.9998C44.3758 34.0353 43.5363 34.8748 42.5008 34.8748C41.4653 34.8748 40.6258 34.0353 40.6258 32.9998V27.2835L31.8758 31.6585V55.2598C31.2335 55.4198 30.623 55.4998 30.0008 55.4998C29.3788 55.4998 28.768 55.4198 28.1258 55.2598V31.6585L5.62988 20.4106C5.84003 19.6581 6.12033 18.9842 6.49428 18.3491C6.75661 17.9036 7.05581 17.4929 7.40003 17.1031L30.0008 28.4035L38.4663 24.1707L15.8084 11.7088Z",
    fill: "#DF7F0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSvgrepoCom1);
export default __webpack_public_path__ + "static/media/box-svgrepo-com 1.b4f5fa245a4969b85277c9b4816fb3ba.svg";
export { ForwardRef as ReactComponent };